export default from './post-list-item-classic';



// WEBPACK FOOTER //
// ./app/components/post-list-item-classic/index.js